export default "__VITE_ASSET__F7AsZq5k__"